import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store/store';

// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';

Vue.config.productionTip = false;

Vue.mixin({
  data: function() {
    return {
      get globalReadOnlyProperty() {
        return "Can't change me!";
      }
    }
  }
})



new Vue({
   router,
   store,
//    mixins: [mixinDetictingMobile],
   render: h => h(App)
}).$mount("#app");

